import gql from "graphql-tag";

export const CREATE_MANDATE_PNVT = gql`
  mutation CreateMandatePnvt($signature: String!) {
    createMandatePnvt(signature: $signature)
  }
`;
